export const OrganizationConfig: any[] = [
  { 
    org_id: 1,
    org_label: 'NASDAQ',
    ccds: 'nasdaq',
    org_access: true,
    csv: '/climatesasb/nasdaq_geo_enc.csv'
  },
  {
    org_id: 9,
    org_label: 'RES',
    ccds: 'rer',
    org_access: true,
    csv: '/climatesasb/sasb_rer.csv'
  },
  {
    org_id: 10,
    org_label: 'Apple',
    ccds: 'apple',
    org_access: true,
    csv: '/climatesasb/sasb_apple_enc.csv'
  },
  {
    org_id: 11,
    org_label: 'Amane Advisors',
    ccds: 'amane',
    org_access: true,
    csv: '/climatesasb/sasb_amane.csv'
  },
  {
    org_id: 14,
    org_label: 'WI Waterkeepers',
    ccds: 'wiwqx',
    org_access: true,
    csv: '/climatesasb/sasb_WIDNR_WQX.csv'
  },
  {
    org_id: 30,
    org_label: 'Pepsi',
    ccds: 'pepsi',
    org_access: true,
    csv: '/climatesasb/sasb_pepsi_enc.csv'
  },
  {
    org_id: 27,
    org_label: 'Apple',
    ccds: 'apple',
    org_access: true,
    csv: '/climatesasb/sasb_apple_enc.csv'
  },
  {
    org_id: 28,
    org_label: 'Apple',
    ccds: 'apple',
    org_access: true,
    csv: '/climatesasb/sasb_apple_enc.csv'
  },
  {
    org_id: 1111,
    org_label: 'Straumann Holdings',
    ccds: 'straumann',
    org_access: true,
    csv: '/climatesasb/sasb_straumann_enc.csv'
  },
  {
    org_id: 1112,
    org_label: 'Tetra Tech',
    ccds: 'tetra',
    org_access: true,
    csv: '/climatesasb/sasb_tetra_enc.csv'
  },
  {
    org_id: 1113,
    org_label: 'Veolia',
    ccds: 'veolia',
    org_access: true,
    csv: '/climatesasb/sasb_veolia_enc.csv'
  }
];
